import { $enum } from "ts-enum-util";
import { UTSLocale } from "@smile2impress/attraction-constants";

import { I18nLocale, I18nLocaleToUTSLocale } from "constants/enum";
import { FALLBACK_LOCALE } from "constants/locale";

export const getI18nLocale = (locale?: string) => {
    return $enum(I18nLocale).asValueOrDefault(locale, FALLBACK_LOCALE);
};

export const getUTSLocale = (locale?: string) =>
    I18nLocaleToUTSLocale[getI18nLocale(locale)] as UTSLocale;
